import React from "react";

export const ServicioSuspendido = () => {
	return (
		<div className="d-flex justify-content-center align-items-center mt-5">
			<h1 className="border border-warning rounded text-warning p-5">Servicio Suspendido !</h1>
		</div>
	);
};
